import { makeFileAccessibleToPublicMutationDocument } from "@/domain/_shared/file/hooks/api/signed-url.gql";
import { PublishedAssetType } from "@/graphql/generated/graphql";
import { createOperationClient } from "@/services/react-query.service/graphql-client";

// Publishes an already-uploaded object and tells the server what it is, so the
// bytes are recorded against the workspace instead of sitting unattributed in the
// bucket.
//
// `assetType` is omitted only where the owning workspace cannot exist yet: a row
// written now would be *tracked* but attributed to nobody, which is worse than no
// row at all, because reconciliation only claims objects it still sees as
// untracked. Leaving it out lets a later run attribute it from the content that
// ends up referencing it.
export async function publishUploadedAsset({
  fileName,
  assetType,
  workspaceId,
}: {
  fileName: string;
  assetType?: PublishedAssetType;
  workspaceId?: string;
}): Promise<string | null> {
  const client = createOperationClient("makeFileAccessibleToPublic");
  const data = await client.request(makeFileAccessibleToPublicMutationDocument, {
    input: { fileName, ...(assetType && { assetType }), ...(workspaceId && { workspaceId }) },
  });

  return data?.makeFileAccessibleToPublic ?? null;
}
